const ROUTE_KEYS = {
    MAIN: '/',
    ASSET_PROCESS: (processName, assetNumber) => { return `/processes/${processName}/${assetNumber}` },
    ASSET_PROCESS_DIRECT_SCAN: (processName, assetNumber) => { return `/processes_directscan/${processName}/${assetNumber}` },
}

export default ROUTE_KEYS
